import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Spinner } from "@/components/States";

export default function ApplyDialog({ item, onClose, onDone }) {
  const [busy, setBusy] = useState(false);
  const run = async (add_line) => {
    setBusy(true);
    try { await api.post(`/prestart/${item.id}/applied`, { add_line }); toast.success(add_line ? "Applied — $0 note line added to the estimate" : "Marked as applied"); onDone(); onClose(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="apply-dialog">
        <DialogHeader>
          <DialogTitle className="section-title">Mark as applied to the estimate</DialogTitle>
          <DialogDescription>{item?.title}. This records who applied it and when. Prices never change on their own — you've already made (or will make) the change in the lines yourself.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-2 sm:grid-cols-2">
          <Button variant="outline" className="rounded-full" disabled={busy} onClick={() => run(false)} data-testid="apply-only">{busy ? <Spinner /> : "Applied"}</Button>
          <Button className="rounded-full" disabled={busy} onClick={() => run(true)} data-testid="apply-with-line">Applied + add $0 note line</Button>
        </div>
        <p className="text-xs text-muted-foreground">The note line is a labelled $0 row under "Pre-start notes" so the saving stays visible on the estimate. Remove it any time, or unmark to take it out.</p>
      </DialogContent>
    </Dialog>
  );
}
